import { render, staticRenderFns } from "./CandidateRegistrationBackgroundComponent.vue?vue&type=template&id=3f0f01bd&"
import script from "./CandidateRegistrationBackgroundComponent.vue?vue&type=script&lang=js&"
export * from "./CandidateRegistrationBackgroundComponent.vue?vue&type=script&lang=js&"
import style0 from "./CandidateRegistrationBackgroundComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports